import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AnalyticsService } from '../analytics.service';
import { NgControl } from '@angular/forms';

export abstract class TrackBase {
  protected resolvedFieldName!: string;
  protected resolvedScreenName!: string;

  constructor(
    protected analytics: AnalyticsService,
    @Inject(DOCUMENT) protected document: Document,
  ) {}

  protected resolveFieldName(
    explicitName?: string,
    control?: NgControl,
  ): string {
    return explicitName || control?.name?.toString() || 'unknown_field';
  }

  protected resolveScreenName(explicitScreen?: string): string {
    return (
      explicitScreen ||
      this.document.title ||
      this.document.location.pathname.replace('/', '') ||
      'unknown_screen'
    );
  }

  protected track(eventName: string, params: Record<string, any>): void {
    this.analytics.trackEvent(eventName, {
      ...params,
      screen_name: this.resolveScreenName(params.screen_name),
    });
  }
}
